export default "__VITE_ASSET__B4w7EcxV__"